import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import GarmentCard from '../../Components/GarmentCard';
import ProductCard, { ProductDetailSkeleton } from '../../Components/ProductCard';
import { Container } from '../../Components/ui/Container/Container';
import Section from '../../Components/ui/Section/Section';
import { Typography } from '../../Components/ui/Typography/Typography';
import { useTrackScreenView } from '../../Hooks/use-track-screen-view';
import { garmentService } from '../../Services';
import { GarmentV3DTO } from '../../Services/garmentService';
import styles from './product-detail.module.scss';

export const ProductDetail = () => {
    const { id } = useParams();
    useTrackScreenView('screen_pdp_view');

    const { data } = useQuery({
        queryKey: ['productDetail', id],
        queryFn: () => garmentService.fetchGarment(id as string),
    });

    return (
        <main>
            <Section>
                <Container>
                    {data ? <ProductCard garment={data} /> : <ProductDetailSkeleton />}
                </Container>
            </Section>
            <Section className={styles.bgGrey}>
                <Container className={styles.container}>
                    <Typography variant="heading1" className={styles.recommendedProductsTitle}>
                        Recommended
                    </Typography>
                    <RecommendedProducts garment={data} />
                </Container>
            </Section>
        </main>
    );
};

interface RecommendedProductsProps {
    garment: GarmentV3DTO | undefined;
}

const RecommendedProducts = ({ garment }: RecommendedProductsProps) => {
    const fetchGarments = () => {
        const tag = garment?.tags.find((tag) => {
            return tag === 'women' || tag === 'men';
        });

        return garmentService.fetchGarmentsByCategory(tag ?? '');
    };

    const { isPending, isError, data, error } = useQuery({
        queryKey: ['garments'],
        queryFn: fetchGarments,
        enabled: !!garment,
    });

    if (!garment) {
        return null;
    }

    const recommendedProducts = data?.garments.filter((item) => item.id !== garment.id).slice(0, 3);

    return (
        <div className={styles.recommendedProducts}>
            {recommendedProducts &&
                recommendedProducts.map((item, index) => (
                    <GarmentCard
                        key={item.id}
                        id={item.id}
                        title={item.title}
                        firstImageUrl={item?.variants?.[0]?.images?.[0]?.url || ''}
                        secondImageUrl={item?.variants?.[0]?.images?.[1]?.url || ''}
                        price={item.variants?.[0]?.price?.amount ?? ''}
                        partnerId={item.partner_id}
                    />
                ))}
        </div>
    );
};
